import request from 'src/network';
import Compressor from 'compressorjs';
const apiPath = `/api/data/v2/sbx/folder`;
const apiPath2 = `/api/ai_agent/folder/file`;
const apiPath3 = `/api/ai_agent/folder`;
const apiPath4 = `/api/data/v2/sbx/file`;

export interface Assets {
    key: string, 
    name: string, 
    mimetype: string,
    size: number,
    mime_type: string;
    url: string;
}

export function createFolderService(keyParent: string, folderName: string) {
    return request.POST<{key: string}>(`${apiPath}/${keyParent}`, {folderName});
}

export function getFolderFilesService(key: string) {
    return request.GET<Assets>(`${apiPath}/${key}`);
}
export function getFilesService(key: string) {
    return request.GET<Assets>(`${apiPath4}/${key}`);
}
export function deleteFileService(key: string) {
    return request.DELETE<any>(`${apiPath2}/${key}`);
}
export function downloadFile(key: string) {
    return request.GET<any>(`/api/content/v1/download/${key}`)
}


export const compressImageService = function(file: File): Promise<File> {
    return new Promise((resolve) => {
        new Compressor(file, {
            quality: 0.6,
            success(fileCompressed) {
                resolve(new File([fileCompressed], file.name, { type: fileCompressed.type }));
            },
            error() {
                resolve(file);
            },
        });
    });
};

export const fileToBase64 = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (e) => reject(e);
    });

export async function uploadFileService(folderKey: string, files: File[]) {
    const filesBase64 = await Promise.all(
        files.map(async (file) => {
            const image = await fileToBase64(file);
            return {
                name: file.name.replaceAll(' ', '_'),
                content: image,
            };
        }),
    );
    const response = await request.POST<any>(`${apiPath3}/${folderKey}`, filesBase64);
    response.items = response.items.map(item => ({
        key: item?.item?.key || '',
        name: item?.item?.name || item?.name,
    }));
    return response;
}

export async function uploadFileCompressedService(folderKey: string, files: File[]) {
    const filesCompressed = await Promise.all(files.map((file) => compressImageService(file)));
    const filesCompressedBase64 = await Promise.all(
        filesCompressed.map(async (file) => {
            const image = await fileToBase64(file);
            return {
                name: file.name.replaceAll(' ', '_'),
                content: image,
            };
        }),
    );
    const response = await request.POST<any>(`${apiPath3}/${folderKey}`, filesCompressedBase64);
    response.items = response.items.map(item => ({
        key: item?.item?.key || '',
        name: item?.item?.name || item?.name,
    }));
    return response;
}